export default __webpack_public_path__ + "media/transfer_window/upsell_survey-cde7e046.png";